import { noop } from '@blocksuite/global/utils';

import { EmbedLinkedDocBlockComponent } from './embed-linked-doc-block.js';
noop(EmbedLinkedDocBlockComponent);

export * from './embed-linked-doc-block.js';
export * from './embed-linked-doc-spec.js';
